let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("hyTuH"), load("87CEF")]).then(() => parcelRequire('9kyXU'));